import UiElement from '../../../shared/ui-element/ui-element';

class FlexArrow extends UiElement {
  onInit() {
    this.makeArrow();
  }

  makeArrow() {
    const titleRect = this.getCoords(document.querySelector('.js-recommended-promo-apps__title'));
    const canvasRect = this.getCoords(document.querySelector('.js-application-summary__arrow'));
    // distance from canvas border to over overflow
    const canvasOffset = 8;

    const p1x = parseFloat(document.getElementById('au').getAttribute('cx'));
    const p1y = parseFloat(document.getElementById('au').getAttribute('cy'));
    const p2x = canvasOffset;
    const p2y = titleRect.top - canvasRect.top + (titleRect.height / 2);

    // mid-point of line:
    const mpx = (p2x + p1x) / 2;
    const mpy = (p2y + p1y) / 2;

    // offset to make line more angular
    const angleOffset = 200;

    // angle of perpendicular to line:
    const theta = Math.atan2(p2y - p1y + angleOffset, p2x - p1x) - Math.PI / 2;

    // distance of control point from mid-point of line:
    const offset = 200;

    // location of control point:
    const c1x = mpx + offset * Math.cos(theta);
    const c1y = mpy + offset * Math.sin(theta);

    const c1 = document.getElementById('cp');
    c1.setAttribute('cx', c1x);
    c1.setAttribute('cy', c1y);

    // construct the command to draw a quadratic curve
    const curve = `M${p1x} ${p1y}Q${c1x} ${c1y} ${p2x} ${p2y}`;
    const curveElement = document.getElementById('curve');
    curveElement.setAttribute('d', curve);
    const curve2 = `m8 ${(p2y + 2)}-8 5.735 7.529 6.264`;
    document.getElementById('arrow').setAttribute('d', curve2);
  }

  getCoords(elem) {
    const {
      width, height, top, left,
    } = elem.getBoundingClientRect();

    return {
      width,
      height,
      top: top + window.pageYOffset,
      left: left + window.pageXOffset,
    };
  }
}

export default FlexArrow;

FlexArrow.initOnDomLoaded();
